import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ContactTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('ContactTypeReference');
  }
}
